import { Controller, useFormContext } from "react-hook-form";
import ReactQuill from "react-quill";

import {
  RICH_TEXT_EDITOR,
  ResignationFormDataType,
} from "@validations/HRM/resignation/resignationFormValidation";

export const RichTextEditor = () => {
  const { control } = useFormContext<ResignationFormDataType>();

  return (
    <></>
    // <div className="col-lg-10 my-8 pb-8 border-bottom">
    //   <Controller
    //     control={control}
    //     name={RICH_TEXT_EDITOR}
    //     render={({ field }) => {
    //       return <ReactQuill theme="snow" value={field.value} readOnly />;
    //     }}
    //   />
    // </div>
  );
};
